import apiClient from '../utils/apiClient';

export async function createLead({
  client_name,
  client_company,
  project_name,
  email,
  phone_number,
  description,
  budget_cost,
  budget_hours,
  location,
  address,
  action_id,
  next_action_due,
  next_action_owner_id,
}) {
  const response = await apiClient.post('/api/leads/', {
    client_name,
    client_company,
    project_name,
    email,
    phone_number,
    description,
    budget_cost,
    budget_hours,
    location,
    address,
    action_id,
    next_action_due,
    next_action_owner_id,
  });
  return response.data;
}

export async function getLeads() {
  const response = await apiClient.get('/api/leads/');
  return response.data;
}

export async function updateLead(lead_id, updatedFields) {
  const response = await apiClient.put(`/api/leads/${lead_id}`, updatedFields);
  return response.data;
}

export const acceptLeadAndCreateProject = async (leadId, overrides = {}) => {
  const response = await apiClient.post(`/api/leads/${leadId}/accept`, overrides);
  return response.data;
};

export async function batchUpdateLeads(ids, patch) {
  const response = await apiClient.patch('/api/leads/batch', { ids, patch });
  return response.data;
}

export async function getFollowUpOverdueCount() {
  try {
    const response = await apiClient.get('/api/leads/follow-ups/overdue-count');
    return response.data.count || 0;
  } catch (err) {
    console.error("getFollowUpOverdueCount error:", err);
    return 0;
  }
}

export async function getClientSuggestions(query) {
  if (!query || query.length < 1) return [];

  try {
    const response = await apiClient.get('/api/leads/client-suggestions', {
      params: { query }
    });
    return response.data; // Expected shape: [{ client_company, client_name }]
  } catch (err) {
    console.error("getClientSuggestions error:", err);
    return [];
  }
}

export async function getAllClientCompanies() {
  try {
    const response = await apiClient.get('/api/leads/client-companies');
    return response.data; // Expected shape: [{ client_company_id, company_name }]
  } catch (err) {
    console.error("getAllClientCompanies error:", err);
    return [];
  }
}

export async function getClientContacts(clientCompanyId = null) {
  try {
    const params = {};
    if (clientCompanyId) params.client_company_id = clientCompanyId;
    
    const response = await apiClient.get('/api/leads/client-contacts', { params });
    return response.data; // Expected shape: [{ client_contact_id, name, email, phone_number, company_name }]
  } catch (err) {
    console.error("getClientContacts error:", err);
    return [];
  }
}

export async function deleteLead(leadId) {
  await apiClient.delete(`/api/leads/${leadId}`);
  return true;
}

// Rows for the lead export
export async function exportLeads(params = {}) {
    const response = await apiClient.get('/api/leads/export', { params });
    return response.data; // { columns, rows }, written to a file by the page
}

// ─── Lead Actions API ──────────────────────────────────────────────

export async function getLeadActions() {
  try {
    const response = await apiClient.get('/api/leads/lead-actions');
    return response.data;
  } catch (error) {
    console.error("Error fetching lead actions:", error);
    throw error;
  }
}

export async function createLeadAction({ name, color, description }) {
  const response = await apiClient.post('/api/leads/lead-actions', { name, color, description });
  return response.data;
}

export async function updateLeadAction(actionId, { name, color, description }) {
  const response = await apiClient.put(`/api/leads/lead-actions/${actionId}`, { name, color, description });
  return response.data;
}

export async function deleteLeadAction(actionId) {
  const response = await apiClient.delete(`/api/leads/lead-actions/${actionId}`);
  return response.data;
}

export async function reorderLeadActions(ids) {
  const response = await apiClient.put('/api/leads/lead-actions/reorder', { ids });
  return response.data;
}

// ─── Lead Statuses API ───────────────────────────────────────────────

export async function getLeadStatuses() {
  const response = await apiClient.get('/api/leads/lead-statuses');
  return response.data;
}

export async function createLeadStatus({ name, color, description, is_closed, is_won, is_lost }) {
  const response = await apiClient.post('/api/leads/lead-statuses', { name, color, description, is_closed, is_won, is_lost });
  return response.data;
}

export async function updateLeadStatus(statusId, { name, color, description, is_closed, is_won, is_lost }) {
  const response = await apiClient.put(`/api/leads/lead-statuses/${statusId}`, { name, color, description, is_closed, is_won, is_lost });
  return response.data;
}

export async function deleteLeadStatus(statusId) {
  const response = await apiClient.delete(`/api/leads/lead-statuses/${statusId}`);
  return response.data;
}

export async function reorderLeadStatuses(ids) {
  const response = await apiClient.put('/api/leads/lead-statuses/reorder', { ids });
  return response.data;
}

// ─── Lead Assignments API ──────────────────────────────────────────

export async function getLeadAssignments(leadId) {
  const response = await apiClient.get(`/api/leads/${leadId}/assignments`);
  return response.data;
}

export async function assignEmployeesToLead(leadId, { assignedBy, employees }) {
  const response = await apiClient.post(`/api/leads/${leadId}/assign`, {
    leadId,
    assignedBy,
    employees,
  });
  return response.data;
}

